import e from "./contact-channels78.js";
function n(r, a) {
  e(r);
  for (var t = r.length - 1; /\s/.test(r.charAt(t)); )
    t -= 1;
  return r.slice(0, t + 1);
}
export {
  n as default
};
//# sourceMappingURL=contact-channels80.js.map
